import React from 'react';
import PropTypes from 'prop-types';
import { pureRender } from 'epic-alt-utils/index';
import root from 'window-or-global';
import NavActions from '../../actions';

let cookiesEnabled = false;
if ((root.navigator && root.navigator.cookieEnabled && document && document.cookie !== undefined) || root.__server_side_render) {
    cookiesEnabled = true;
}

@pureRender
export default class Alert extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            dismissed: true
        };

        this.defaultStatus = 'https://epicgames.com/status';
    }

    static propTypes = {
        id: PropTypes.string,
        statusHref: PropTypes.string,
        type: PropTypes.string,
        msg: PropTypes.string,
        hidden: PropTypes.bool,
        cookies: PropTypes.object
    };

    static contextTypes = {
        globalLinkOnClick: PropTypes.func
    };

    componentDidMount() {
        if (this.props.id && this.props.msg && cookiesEnabled && typeof this.props.cookies === 'object') {
            const dismissed = !!this.props.cookies.get(`egh-alert-${this.props.id}`);
            if (dismissed !== this.state.dismissed) {
                this.updateDismissed(dismissed);
            }
        }
    }

    updateDismissed(dismissed) {
        this.setState({
            dismissed
        });
    }

    onClick = (e) => {
        const href = this.props.statusHref || null;
        if (this.context.globalLinkOnClick && typeof this.context.globalLinkOnClick === 'function') {
            this.context.globalLinkOnClick(e, href);
        }
    };

    closeAlert = (e) => {
        const id = this.props.id;
        const cookies = this.props.cookies || {};

        NavActions.alertActive(false);

        this.setState({
            dismissed: true
        });

        let host = window.location.hostname;
        const re = /([\w-]+\.[\w-]+)$/g;
        const matches = host.match(re);
        //remove any subdomain
        if (matches && matches.length) {
            host = matches[0];
        }

        const expires = new Date();
        expires.setYear(expires.getFullYear() + 1); //expire in a year
        const domain = `.${host}`;
        const options = { expires, domain, path: '/' };
        if (host === 'localhost') {
            delete options.domain;
        }

        cookies.set(`egh-alert-${id}`, 'dismissed', options);
    };

    /**
     * Allow for additional names to render the alert.
     * normal === success === green
     * info === grey
     * critical === warning === yellow
     * blocker === danger === red
     * @return {[type]} [description]
     */
    getType() {
        const type = this.props.type || 'info';
        if (type === 'normal' || type === 'green') {
            return 'success';
        } else if (type === 'grey') {
            return 'info';
        } else if (type === 'critical' || type === 'yellow') {
            return 'warning';
        } else if (type === 'blocker' || type === 'red') {
            return 'danger';
        }
        return type;
    }

    render() {
        if (this.props.hidden) {
            return (<div className="egh-alert-hidden" />);
        }
        const id = this.props.id || null;
        const msg = this.props.msg || null;
        const type = this.getType();
        const statusHref = this.props.statusHref || this.defaultStatus;
        const dismissed = this.state.dismissed;

        if (dismissed) {
            return (<div className="egh-alert-dismissed" />);
        }

        if (!id || !msg) {
            return (<div />);
        }

        const html = { __html: msg };

        return (
            <div className={`egh-alert egh-alert-${type}`} id="eghAlert">
                <a role="button" tabIndex="0" className="egh-alert-close-btn alert-link pull-right" onClick={this.closeAlert}>
                    <i className="eg-header-icon-close" />
                </a>
                <a href={statusHref} target="_blank" onClick={this.onClick} className="alert-status-link alert-link">
                    <i className={`eg-header-icon-${type}`} />
                </a>
                <div className="msg">
                    <p className="alert-msg" dangerouslySetInnerHTML={html} />
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./app/scripts/components/alert/Alert.js